export const extraMarkets = [
  {
    name: "Canada (English)",
    culture: "en-CA",
  },
  {
    name: "Canada (French)",
    culture: "fr-CA",
  },
  {
    name: "New Zealand",
    culture: "en-NZ",
  },
  {
    name: "Belgium (Dutch)",
    culture: "nl-BE",
  },
  {
    name: "Belgium (French)",
    culture: "fr-BE",
  },
];
